import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import { transactionData_mock } from './mock.js'
import { getUvid } from '@/utils/uvid'
import { getFissionParams } from './fission'

/**
 * 查询账户余额
 * @param {Number} accountType // 账户类型 1: K币账户
 * @param {String} userId // kicoinId
 */
export function queryAccountBalance(options, useMock) {
  if (!useMock) {
    return request.postJson(
      {
        url: '/api/account/info/query',
        data: { ...deleteEmpty(options) },
      },
      {
        showLoading: false,
      }
    )
  } else {
    return Promise.resolve({
      amount: 1000000,
      status: 1,
    })
  }
}

/**
 * 更换钱包账户绑定邮箱
 * @param
 */

export function updataWalletMailbox(payload, useMock) {
  if (!useMock) {
    return request.postJson(
      {
        url: '/api/verify/code/checkOrUpdateEmail',
        data: { ...deleteEmpty(payload) },
      },
      {
        showLoading: false,
      }
    )
  } else {
    // return Promise.resolve({ ifPass: true })
    return Promise.reject({
      code: 21011,
    })
  }
}

let pInd = 1
export function queryTransactionList(payload, useMock) {
  if (!useMock) {
    return request.postJson(
      {
        url: '/api/account/detail/query',
        data: { ...deleteEmpty(payload) },
      },
      {
        showLoading: false,
      }
    )
  } else {
    const { pageNo, pageSize } = payload
    pInd = pageNo
    return Promise.resolve(transactionData_mock(pInd++, pageSize))
  }
}

/***
 * 钱包充值
 * country 国家类型
 * email 用户email
 * game: "toplupe" // 钱包专属名称
 * goodsCount // 商品数额，非自定义金额默认为 1
 * isRoute // 默认为 true
 * payMethod 通道名
 * payPrice // 支付价格
 * skuId // 套餐id
 * skuName // 套餐名称
 * source // 业务渠道
 * uid: // 钱包账户id，目前就是 mocoinId
 * sign // 签名验证码
 */
export function placeOrder(options = {}, useMock = false) {
  if (useMock) {
    return Promise.reject({
      code: 20015,
    })
  }
  options = {
    uvid: getUvid(),
    ...getFissionParams(),
    ...options,
  }
  return request.postJson({
    url: appendApiUrl('/order/wallet/recharge'),
    data: { ...deleteEmpty(options) },
  })
}
